import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { wellnessBaseUrl } from "network";

export const concernSlice = createApi({
    reducerPath: "concernSlice",
    baseQuery: fetchBaseQuery({
        baseUrl: wellnessBaseUrl,
        credentials: "include",
        prepareHeaders: (headers, { getState }) => {
            const state = getState();
            const token = state.auth?.token;
            if (token) {
                console.log('token', token);
                headers.set("authorization", `Bearer ${token}`);
            } else {
                console.warn("Token not found in state.auth");
            }
            return headers;
        },
    }),
    endpoints: (builder) => ({
        // ✅ Get All Categories
        getConcerns: builder.query({
            query: ({ page = 1, limit = 100, search = "" }) => ({
                url: `/concern?page=${page}&limit=${limit}&search=${search}`,
                method: "GET",
            }),
            transformResponse: (response) => response,
        }),


        // ✅ Add New Category
        addConcern: builder.mutation({
            query: (body) => ({
                url: "/concern",
                method: "POST",
                body,
            }),
        }),

        getOneConcern: builder.query({
            query: (id) => ({
                url: `/concern/${id}`,
                method: "GET",

            }),
        }),

        // ✅ Update Existing Category
        updateConcern: builder.mutation({
            query: ({ id, body }) => ({
                url: `/concern/${id}`,
                method: "PUT",
                body,
            }),
        }),

        // ✅ Delete Category
        deleteConcern: builder.mutation({
            query: (id) => ({
                url: `/concern/${id}`,
                method: "DELETE",
            }),
        }),

        getResponseConcern: builder.query({
            query: ({ page = 1, limit = 100, search = "" }) => ({
                url: `/concern/linked-concern?page=${page}&limit=${limit}&search=${search}`,
                method: "GET",
            }),
            transformResponse: (response) => response,
        }),

        getAppointments: builder.query({
            query: ({ page = 1, limit = 10, search = "" }) => ({
                url: `/appointment/list?page=${page}&limit=${limit}&search=${search}`,
                method: "GET",
            }),
            transformResponse: (response) => response,
        }),

        updateAppointmentResponse: builder.mutation({
            query: ({ id, body }) => ({
                url: `/appointment/${id}`,
                method: "PUT",
                body,
            }),
        }),
    }),
});

export const {
    useGetConcernsQuery,
    useAddConcernMutation,
    useGetOneConcernQuery,
    useUpdateConcernMutation,
    useDeleteConcernMutation,
    useGetResponseConcernQuery,
    useGetAppointmentsQuery,
    useUpdateAppointmentResponseMutation,
} = concernSlice;
